import { render } from "./detail.vue?vue&type=template&id=c15325ec&scoped=true&ts=true"
import script from "./detail.vue?vue&type=script&lang=ts"
export * from "./detail.vue?vue&type=script&lang=ts"

import "./detail.vue?vue&type=style&index=0&id=c15325ec&lang=less&scoped=true"
import "./detail.vue?vue&type=style&index=1&id=c15325ec&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c15325ec"]])

export default __exports__